import React, { useEffect } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PaginateValePedagioTaxasState } from 'store/ducks/settings/vale-pedagio-taxas';
import { useTranslation, usePermissions } from 'hooks';
import * as S from './styles';
import { translations } from './translations';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridValePedagioTaxas } from 'components/settings/ValePedagioTaxas/GridValePedagioTaxas';
import { useFilters } from 'hooks/useFilters';

export const ListValePedagioTaxas: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { getData } = useFilters('valePedagioTaxas');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateValePedagioTaxas
  ) as PaginateValePedagioTaxasState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="vale-pedagio-taxas" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          <S.ButtonMini
            onClick={() => history.push('/settings/vale-pedagio-taxas/new')}
          >
            {getTranslation('novaTaxa')}
          </S.ButtonMini>
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridValePedagioTaxas taxas={data} />
        <Paginator
          pagination={pagination}
          settingsPage='valePedagioTaxas'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};